import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import LoginLeftContentSvg from '../svgs/LoginLeftContentSvg';
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router-dom';
import '../css/loginPageCss.css';

const LoginPage = () => {
  const alert = useAlert();
  const navigate = useNavigate();

  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [checkingCredentials, setCheckingCredentials] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const passwordInputId = 'password-input';

  // get current date
  let todaysDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');

  // checking credentials
  useEffect(() => {
    // window.location.reload()

    const credentialsInfo = JSON.parse(localStorage.getItem('myLoginDetails'));

    if (credentialsInfo === null || credentialsInfo === undefined) {
      localStorage.setItem('myLoginDetails', JSON.stringify(''));
      window.location.reload();
    } else {
      let checkLoginDetails = JSON.parse(localStorage.getItem('loginDetails'));
      if (checkLoginDetails === null || checkLoginDetails === undefined) {
        localStorage.setItem(
          'logoUrl',
          JSON.stringify(
            'https://niroggyan.s3.ap-south-1.amazonaws.com/new-billing-dashboard-files/logos/niroggyan-logo.svg'
          )
        );
        window.dispatchEvent(new Event('storage'));
        //
      } else {
        if (credentialsInfo.toUpperCase() === checkLoginDetails.org) {
          navigate('/');
        }
      }
    }
  }, []);

  const loginFormHandler = async e => {
    e.preventDefault();

    setCheckingCredentials(true);

    let dataToSend = {
      username: username,
      password: password,
      // type: 'login',
    };

    // login endpoint
    var config = {
      method: 'POST',
      //url: '',
      url: 'https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/client/login',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(dataToSend),
    };

    try {
      // EXPIRING LOGIN SESSION
      // var datetime = new Date().toLocaleString().replace(',', '')

      const axiosData = await axios(config);
      // console.log(
      //   'inside axiosdata ===> \n\n',
      //   axiosData.data.data.userDetails.accessTo.dashBoard
      // );
      if (axiosData.data.data.userDetails.accessTo) {
        if (axiosData.data.data.userDetails.accessTo.dashBoard) {
          localStorage.setItem('clientPreference', JSON.stringify('none'));
          localStorage.setItem(
            'idTokenBilling',
            axiosData.data.data.authTokens.idToken
          );
          // Save refresh token so we can silently renew idTokenBilling every 50 min
          // without forcing the user to log out
          if (axiosData.data.data.authTokens.refreshToken) {
            localStorage.setItem(
              'refreshTokenBilling',
              axiosData.data.data.authTokens.refreshToken
            );
          }
          if (axiosData.data.data.clientData) {
            localStorage.setItem(
              'loginDetails',
              JSON.stringify({
                ...axiosData.data.data.userDetails,
                clientData: [...axiosData.data.data.clientData],
              })
            );
          } else {
            localStorage.setItem(
              'loginDetails',
              JSON.stringify({
                ...axiosData.data.data.userDetails,
              })
            );
          }

          localStorage.setItem(
            'logoUrl',
            JSON.stringify(axiosData.data.data.userDetails.logoSrc)
          );
          localStorage.setItem('myLoginDetails', JSON.stringify(username));
          localStorage.removeItem('orgPreference');

          let orgName = axiosData.data.org;
          let centerName = axiosData.data.center;
          let lisName = axiosData.data.role;

          // once login is successful fetch the actual data (followed by org and center name)
          let homePageApi = `https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/clientdashboard/home/?org=${orgName}&center=${centerName}`;
          let homePageApiForLIS = `https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/clientdashboard/home/?org=${orgName}&center=${centerName}&query_on=${lisName}`;
          let adminEndPoint = `https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/testquery?org=any&center=any`;

          let endpointToUse;

          if (lisName === 'lab') {
            endpointToUse = homePageApi;
          } else if (lisName === 'LIS') {
            endpointToUse = homePageApiForLIS;
          } else {
            endpointToUse = adminEndPoint;
          }

          console.log('using endpoint: ', endpointToUse);

          var config2 = {
            method: lisName === 'lab' || lisName === 'LIS' ? 'GET' : 'POST',
            // url: "",
            url: endpointToUse,
            headers: {
              'Content-Type': 'application/json',
            },
          };
          // const sampleLoginDetails = {
          //   username: username,
          //   password: password,
          // };
          // const loginApiConfig = {
          //   url: 'https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/oauth/token?grant_type=credentials',
          //   method: 'POST',
          //   data: JSON.stringify(sampleLoginDetails),
          // };

          // const loggingIn = async () => {
          //   const response = await axios(loginApiConfig);
          //   console.log('response From OAuth', response);
          //   const idToken = response.data.data.IdToken;
          //   localStorage.setItem('idTokenBilling', idToken);
          // };

          try {
            // await loggingIn();
            setCheckingCredentials(false);
            //console.log("axiosData2: ", axiosData2)
            localStorage.setItem('loggedOn', JSON.stringify(todaysDate));
            // save precise login timestamp (ms since epoch) for auto-logout tracking
            // also save lastTokenRefresh so the startup elapsed-time check in App.js
            // has the correct baseline from the moment of login
            try {
              const now = String(Date.now());
              localStorage.setItem('loginTimestamp', now);
              localStorage.setItem('lastTokenRefresh', now);
            } catch (_) { }
            // localStorage.setItem('homepageData', JSON.stringify(axiosData2));
            navigate('/new-billing-dashboard');
            alert.success('Login Successful!');

            // dispatchEvent => so that the event listener can notice the changes in local storage
            // (will make the navbar component to re render)
            window.dispatchEvent(new Event('storage'));
          } catch (error) {
            console.log('Homaepage API Error:\n', error);
          }
        } else {
          localStorage.setItem('maintenance', 'true');
          navigate('/maintenance');
          window.location.reload();
          localStorage.setItem('loginDetails', JSON.stringify(axiosData.data));
        }
      } else {
        navigate('/maintenance');
        localStorage.setItem('maintenance', 'true');
        localStorage.setItem('loginDetails', JSON.stringify(axiosData.data));
      }
    } catch (error) {
      setCheckingCredentials(false);
      console.log(error.message);
      alert.error(
        <span style={{ fontSize: '15px' }}>{'Invalid Credentials!'}</span>
      );
    }
  };

  return (
    <div className='login-page-container'>
      {/* Left Content - Visual Section */}
      <div className='login-visual-section'>
        <div className='login-visual-content'>
          <div className='login-visual-svg-wrapper'>
            <LoginLeftContentSvg />
          </div>
        </div>
      </div>

      {/* Right Content - Form Section */}
      <div className='login-form-section'>
        <div className='login-form-wrapper'>
          <div className='login-header'>
            <div className='login-title'>Welcome Back</div>
            <div className='login-subtitle'>
              Dashboard allows you to track your smart reports consumption and have quick analysis on important business metrics
            </div>
          </div>

          <form onSubmit={loginFormHandler}>
            <div className='login-form-group'>
              <label className='login-label'>Username</label>
              <input
                type='text'
                name='username'
                className='login-input'
                value={username}
                onChange={e => setUserName(e.target.value)}
                placeholder='Enter your username'
                autoComplete="username"
              />
            </div>

            <div className='login-form-group'>
              <label className='login-label' htmlFor={passwordInputId}>Password</label>
              <input
                id={passwordInputId}
                type={showPassword ? 'text' : 'password'}
                name='password'
                className='login-input'
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder='••••••••'
                autoComplete="current-password"
              />
            </div>

            <div className='password-toggle-container'>
              <input
                type='checkbox'
                id='show-password'
                className='custom-checkbox'
                checked={showPassword}
                onChange={e => setShowPassword(e.target.checked)}
              />
              <label htmlFor='show-password' className='checkbox-label'>
                Show Password
              </label>
            </div>

            <button
              disabled={checkingCredentials}
              type='submit'
              className='login-button'
            >
              {checkingCredentials ? (
                <>
                  Checking Credentials
                  <Spinner animation='border' size='sm' style={{ marginLeft: '10px' }} />
                </>
              ) : (
                'Login'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
